import React from 'react';
import { connect } from 'react-redux';
import { CallbackFunction, RootState } from '@share/utils';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { FormattedMessage, injectIntl, WrappedComponentProps } from 'react-intl';
import { SorterResult, TablePaginationConfig } from 'antd/lib/table/interface';
import { ICompanyBookingsState, getCompanyBookings, getCompanyBookingStatic, companyBookingsActions, downloadCompanyBookingVoucher, voucherCompanyBooking, cancelCompanyBooking } from '@share/store/slices';
import { IFilterField, ICompanyBooking, ICompanyBookingsFilters, ITextSearch } from '../../../share/common-types/company-bookings';
import SideNav from '../company-settings/side-nav/component';
import BookingsTable from './bookingsTable';
import { Spin } from 'antd';

interface IMapStateToProps {
  companyBookingsStore: ICompanyBookingsState;
}

interface IMapDispatchToProps {
  getCompanyBookings: (status: string) => void;
  getCompanyBookingStatic: (id: number) => void;
  setFilters: (filters: ICompanyBookingsFilters) => void;
  setPagination: (pagination: TablePaginationConfig) => void;
  setSort: (sort: SorterResult<ICompanyBooking>) => void;
  setBookingType: (bookingType: IFilterField<string>) => void;
  cancelCompanyBooking: (bookingId: string, comment: string, callback: CallbackFunction) => void;
  voucherCompanyBooking: (bookingId: string, recepientEmail: string, additionalEmail: string, callback: CallbackFunction) => void;
  downloadCompanyBookingVoucher: (bookingId: string) => void;
  resetFilters: () => void;

  setTextSearch: (textSearch: ITextSearch) => void;
  setTextSearchLabel: (textSearchLabel: string) => void;
}

interface IProps extends IMapStateToProps, IMapDispatchToProps, RouteComponentProps, WrappedComponentProps { }

function CompanyBookingsComponent(props: IProps) {

  return (
    <section className="pt-3">
      <div className="container">
        <div className="row">
          <SideNav />
          <div className="col-lg-8 col-xl-9">
            <div className="card shadow-sm bg-transparent border">
              <div className="card-header bg-transparent border-bottom">
                <h4 className="card-header-title">
                  <i className="bi bi-suitcase-lg mx-2"></i><FormattedMessage id="my.bookings" />
                </h4>
              </div>
              <div className="card-body p-2 p-sm-4">
                <Spin spinning={props.companyBookingsStore.loading}>
                  <div className="tab-content">
                    <BookingsTable
                      title="companyBooking.search.title"
                      store={props.companyBookingsStore}
                      getCompanyBookings={props.getCompanyBookings}
                      getCompanyBookingStatic={props.getCompanyBookingStatic}
                      setBookingType={props.setBookingType}
                      setFilters={props.setFilters}
                      setPagination={props.setPagination}
                      setSort={props.setSort}
                      resetFilters={props.resetFilters}
                      setTextSearch={props.setTextSearch}
                      setTextSearchLabel={props.setTextSearchLabel}
                      cancelCompanyBooking={props.cancelCompanyBooking}
                      voucherCompanyBooking={props.voucherCompanyBooking}
                      downloadCompanyBookingVoucher={props.downloadCompanyBookingVoucher} />
                  </div>
                </Spin>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

const mapStateToProps = (state: RootState): IMapStateToProps => {
  return {
    companyBookingsStore: state.companyBookingsStore,
  };
};

const mapDispatchToProps: IMapDispatchToProps = {
  getCompanyBookings,
  getCompanyBookingStatic,
  setFilters: companyBookingsActions.setFilters,
  setPagination: companyBookingsActions.setPagination,
  setSort: companyBookingsActions.setSort,
  resetFilters: companyBookingsActions.resetFilters,
  setTextSearch: companyBookingsActions.setTextSearch,
  setTextSearchLabel: companyBookingsActions.setTextSearchLabel,
  setBookingType: companyBookingsActions.setBookingType,
  cancelCompanyBooking: cancelCompanyBooking,
  voucherCompanyBooking: voucherCompanyBooking,
  downloadCompanyBookingVoucher: downloadCompanyBookingVoucher,
};

const ComponentIntl = injectIntl(CompanyBookingsComponent);

const CompanyBookings = connect(mapStateToProps, mapDispatchToProps)(withRouter(ComponentIntl));
export default CompanyBookings;